'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RouterActions = require('../../../core/actions/RouterActions');

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _Lazy = require('../../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var domainOnlyStep = function domainOnlyStep() {
  var nextStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _appStepRoutes.GETTING_STARTED;

  return {
    route: _appStepRoutes.DOMAIN,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.DomainOnly, props)
      );
    },
    props: {
      handleSubmit: _RouterActions.goToStep.bind(null, nextStep),
      nextStep: nextStep
    }
  };
};

exports.default = domainOnlyStep;
module.exports = exports['default'];